export default "__VITE_ASSET__CtyCTac5__"